var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from './InputMask.styles';
import { ErrorIcon } from '../icons';
import InputMasks from 'react-input-mask';
const InputMask = (_a) => {
    var { name, type, label, error, texterror, fullWidth, maskPlaceholder, alwaysShowMask } = _a, props = __rest(_a, ["name", "type", "label", "error", "texterror", "fullWidth", "maskPlaceholder", "alwaysShowMask"]);
    return (_jsxs(S.Container, Object.assign({ fullWidth: fullWidth !== null && fullWidth !== void 0 ? fullWidth : false }, { children: [_jsx(S.Label, { children: label }, void 0), _jsx(InputMasks, Object.assign({ mask: props.mask, value: props.value, onChange: props.onChange, alwaysShowMask: alwaysShowMask, maskPlaceholder: maskPlaceholder, 
                // @ts-ignore:next-line
                maskChar: " " }, { children: () => (_jsxs(S.Wrapper, { children: [_jsx(S.Input, { name: name, error: error, placeholder: props.placeholder }, void 0), error ? (_jsx(S.IconSvg, Object.assign({ error: true }, { children: _jsx(ErrorIcon, {}, void 0) }), void 0)) : undefined] }, void 0)) }), void 0), _jsx(S.Error, { children: error ? texterror : '' }, void 0)] }), void 0));
};
export { InputMask };
//# sourceMappingURL=InputMask.js.map